/**
 * Serviço de impressão via QZ Tray
 *
 * Requer que o agente "QZ Tray" esteja instalado e rodando
 * na máquina do usuário: https://qz.io
 *
 * Funciona em Windows e Mac sem configuração adicional.
 */

// eslint-disable-next-line @typescript-eslint/no-var-requires
const qz = require('qz-tray');

export interface ZebraDevice {
  connection: string;
  deviceType: string;
  manufacturer?: string;
  name: string;
  provider: string;
  uid: string;
  version: number;
}

const CHAVE_PRIVADA = `-----BEGIN PRIVATE KEY-----
MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDGxEl4/dBp0cCC
vJ6XWeuL29kwFCbi4ECTgzIZNr3ALvIpI/r0jv39YU76SpMMk5ylD6cBKhz5qiqH
vacEdXyvUmJwsl19SkbjWY3iaAZKulpVaK0NH5EbSAtGEE88JsAPlrcQf2fgpT37
wDBHStshI9taCexRKNBlIXVvk9XiddRncphqARjSFmTn0VhirJ2PbGgw8/u165TA
wGuPCZbxzzLzsCJ7jKNr7G/1FOJ0MAzVWInDO7/Wfbj/YtzaYzDgNixRKJ71JBZM
SIAFORrxrdsrI/6k6Svgaq5PGq+fJTAN4E1cDz+nyCv1oodDgt4Jaz0JReYvHtt+
2fzatP0RAgMBAAECggEAGTalAKK8YUVTikIATBVX+nHKPH28lmL5ThJXtI3BHDPY
UWetryrEWp6RX3vo6LDWL19WQUuPnral6890SZiDAdUNhQYwiHLM8zdU9uIDNPor
+KbtQhDoXfGRnIhNGhrq72SgQYjSgH31kuMaPLDo2GytUoqXs46IgODxqKm0I/my
ZUPwlzPP+wicn7hgKMnuSz6fWIAkAQG+5XpYqOXSd8sE6MOiE94SKZhB7hWcHjCE
kXR6/Stqn2v4rXX5npRI/2pgFIpRw4O3UuzyMQ5iA8rQoXZu1Eduib0fmmXf+3/t
PoTTbNcmbi4UizkuyGCaIUbxTes/yi7CB6A3Gd9dUQKBgQDxT1TeZe6YT3LEzndl
+WU9gkX2/xbsS6SvDgQjYv9udMqBQ/NXH4RJKJALfoSxvZid+WcGPsNEq+7BfvlC
CcGL2FAWUOm9ppwc4M3LDuliiahw9R2C6+OS3nNS6G/YLHsOKYhU9rajsaRbBG9G
yC/tcxgpfecNLjEYaZjGhXFdQwKBgQDS3fJFRZbb3CtqoW38uN42Iq18bkbFOmPO
Mg+Qn2D5tshwiIKG46T4Lz/0GI2osUaA/MIJUUdXJxIazxTD2z98mO/VFGnhKw1T
v9inzYXIMB1rzcP1n8iJ/Dp8y99IPAS5xjmb9n2qnpZeJLdwjebBZOXngM0pEJNi
ujMrGdFNGwKBgHK4qXt18GG+26xPEBqN36DHb2XGzmoWaDvFKRh9tzwXEDM2T9jq
peR2AU1Fn+Y0Yfswl9czPXhHWSHqsKvBoZ9PfnutigJc1DkycwQHmdL76PWSwq38
YVvwn9kZohqewv3vpt3l0Nyv1phi2lhHUenMXv9S2Oa+QB8ADN7MkCGrAoGBAJpm
P0YvrUWxUe0S5MkeyD6VZ7hrutAhcAEEMNdxi/1stBmKKyD/wMSlPEvMSrWRkJFU
AfP2mqkbB6uvo4HBoRvnk/zOpLRl5K1FFSvRVjr92B0ennTUmW9Hy7+jPAvVPpSU
q4wikWOEGZA3jEYS8Tr8WUcIzbBa3cB1nI/bqKCvAoGAE1cDVdwqkt5QXs8jxrIv
AhnR9XRjMgH1/hT6tF9Im/cagQN9lWzXpRxyHL+3sZ4O6DptuVpuyo2h/MrjRM7M
gHcYuZkLrDxeC4AUp9rAI6XlHnT/1zK1F28WwaW9+lRtTcsq7k7ggkKFZtNj4Dr5
b1uJjViiotF0F8Z8KrIEqcU=
-----END PRIVATE KEY-----`;

const CERTIFICADO = `-----BEGIN CERTIFICATE-----
MIIDGTCCAgGgAwIBAgIUO2NDiCnB3QVITTLc/wsqp51KvJ8wDQYJKoZIhvcNAQEL
BQAwHDEaMBgGA1UEAwwRbHctZG9jLWltcHJlc3NvcmEwHhcNMjYwMzI2MTkxNTQx
WhcNMzYwMzIzMTkxNTQxWjAcMRowGAYDVQQDDBFsdy1kb2MtaW1wcmVzc29yYTCC
ASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEBAMbESXj90GnRwIK8npdZ64vb
2TAUJuLgQJODMhk2vcAu8ikj+vSO/f1hTvpKkwyTnKUPpwEqHPmqKoe9pwR1fK9S
YnCyXX1KRuNZjeJoBkq6WlVorQ0fkRtIC0YQTzwmwA+WtxB/Z+ClPfvAMEdK2yEj
21oJ7FEo0GUhdW+T1eJ11GdymGoBGNIWZOfRWGKsnY9saDDz+7XrlMDAa48JlvHP
MvOwInuMo2vsb/UU4nQwDNVYicM7v9Z9uP9i3NpjMOA2LFEonvUkFkxIgAU5GvGt
2ysj/qTpK+Bqrk8ar58lMA3gTVwPP6fIK/Wih0OC3glrPQlF5i8e237Z/Nq0/REC
AwEAAaNTMFEwHQYDVR0OBBYEFFpMEP/lCznHffzXSeFawBBmzihEMB8GA1UdIwQY
MBaAFFpMEP/lCznHffzXSeFawBBmzihEMA8GA1UdEwEB/wQFMAMBAf8wDQYJKoZI
hvcNAQELBQADggEBAItgn05aCH8BkCFQeQO5+szgxxnSzk+hPIA+V7wfn7IAfEWR
/EL2sY9MZ3xhsgTnyD0gB54GELegikSLeWEA7IO7Xf530wbI2uPoTmFz+W5XUMQ7
e4VmARFI/W23pT9PC6WMIUZj4wU38PQpN+M5CH8oJNK/rpwozkhXqchG/oLAwdjQ
vKbfoEk1ACYyMABbP0gzi/oPSincLDViOgDLbIqF3o6LcvyKWR0BtC2q3HqtzHi1
MEQzSpVmrpwqAZQCA4kkxdHCMoj3IJdVmJdj7oT9yqB/xVft+UfXjm8DcQVi7NmJ
WUnR32zeoZ7eId+PSIFxy+9eqsIb5UFfdhoWzyU=
-----END CERTIFICATE-----`;

async function assinar(toSign: string): Promise<string> {
  try {
    const pemBody = CHAVE_PRIVADA
      .replace(/-----BEGIN PRIVATE KEY-----/, '')
      .replace(/-----END PRIVATE KEY-----/, '')
      .replace(/\s+/g, '');
    const binaryStr = atob(pemBody);
    const der = new Uint8Array(binaryStr.length);
    for (let i = 0; i < binaryStr.length; i++) {
      der[i] = binaryStr.charCodeAt(i);
    }
    const key = await crypto.subtle.importKey(
      'pkcs8',
      der,
      { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-1' },
      false,
      ['sign']
    );
    const assinatura = await crypto.subtle.sign(
      'RSASSA-PKCS1-v1_5',
      key,
      new TextEncoder().encode(toSign)
    );
    const bytes = new Uint8Array(assinatura);
    let binary = '';
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    const assinaturaB64 = btoa(binary);
    console.log('[QZ] Assinatura gerada com sucesso, tamanho:', assinaturaB64.length);
    return assinaturaB64;
  } catch (e) {
    console.error('[QZ] ERRO ao assinar:', e);
    throw e;
  }
}

export function baixarCertificado() {
  const blob = new Blob([CERTIFICADO], { type: 'application/x-pem-file' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'certificado-impressora.pem';
  a.click();
  URL.revokeObjectURL(url);
}

let _reconectando = false;

function configurarSeguranca() {
  qz.security.setCertificatePromise((resolve: Function) => resolve(CERTIFICADO));
  qz.security.setSignaturePromise((toSign: string) => (resolve: (v: string) => void, reject: (e: any) => void) =>
    assinar(toSign).then((sig) => resolve(sig)).catch(reject)
  );
}

function configurarReconexaoAutomatica() {
  qz.websocket.setClosedCallbacks(async () => {
    if (_reconectando) return;
    _reconectando = true;
    let tentativa = 0;
    while (!qz.websocket.isActive() && tentativa < 10) {
      tentativa++;
      await new Promise((res) => setTimeout(res, 3000 * tentativa));
      try {
        configurarSeguranca();
        await qz.websocket.connect();
      } catch {
        // continua tentando
      }
    }
    _reconectando = false;
  });
}

async function conectar(): Promise<void> {
  configurarSeguranca();
  if (!qz.websocket.isActive()) {
    await qz.websocket.connect();
    configurarReconexaoAutomatica();
  }
}

function nomeParaDevice(nome: string): ZebraDevice {
  return {
    name: nome,
    connection: 'usb',
    deviceType: 'printer',
    provider: 'qz-tray',
    uid: nome,
    version: 2,
  };
}

export async function buscarImpressoraPadrao(): Promise<ZebraDevice> {
  await conectar();
  const resultado: string | string[] = await qz.printers.find();
  const lista = Array.isArray(resultado) ? resultado : [resultado];
  if (!lista.length || !lista[0]) {
    throw new Error(
      'Nenhuma impressora encontrada. Verifique se o QZ Tray está rodando e se há impressoras instaladas.'
    );
  }
  const zebraPrinter = lista.find((nome: string) =>
    /zebra|zd220|ztc|zpl/i.test(nome)
  );
  if (zebraPrinter) return nomeParaDevice(zebraPrinter);
  const nomePadrao: string = await qz.printers.getDefault();
  return nomeParaDevice(nomePadrao || lista[0]);
}

export async function listarImpressoras(): Promise<ZebraDevice[]> {
  await conectar();
  const resultado: string | string[] = await qz.printers.find();
  const lista = Array.isArray(resultado) ? resultado : [resultado];
  return lista.map(nomeParaDevice);
}

export async function enviarZpl(zpl: string, device?: ZebraDevice): Promise<void> {
  await conectar();
  const impressora = device ?? (await buscarImpressoraPadrao());
  const config = qz.configs.create(impressora.name);
  const bytes = new TextEncoder().encode(zpl);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) { binary += String.fromCharCode(bytes[i]); }
  await qz.print(config, [{ type: 'raw', format: 'base64', data: btoa(binary) }]);
}
